const BoxLeft = (props) => {

    return <>
        <div className="boxleft w-full md:w-2/5">
            {props.children}
        </div>
    </>
}

export default BoxLeft;